import { DARK_SCHEME_QUERY, useMediaQuery } from '@/components/base'
import { useThemeStore } from '@/stores/use-theme-store'

/**
 * Whether the app is currently showing its dark palette.
 *
 * Every colour in the app is a `light-dark()` pair that resolves itself, so
 * this is only for the few places that have to *name* the theme rather than
 * wear it — a control offering the other one, or a third-party editor that
 * takes it as a prop.
 *
 * Read live rather than snapshotted: a machine that turns dark at sunset must
 * carry those places with it.
 */
export function useIsDarkTheme(): boolean {
  const choice = useThemeStore(state => state.choice)
  const prefersDark = useMediaQuery(DARK_SCHEME_QUERY)
  return choice ? choice === 'dark' : prefersDark
}
